import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const AnnouncementBar = () => {
  const [announcement, setAnnouncement] = useState({ text: '', enabled: false });
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const fetchAnnouncement = async () => {
      try {
        const res = await fetch(`${API_URL}/api/announcement`);
        if (res.ok) {
          const data = await res.json();
          setAnnouncement(data);
        }
      } catch (error) {
        console.error('Error fetching announcement:', error);
      }
    };
    fetchAnnouncement();
  }, []);

  if (!announcement.enabled || dismissed || !announcement.text) {
    return null;
  }

  return (
    <div 
      className="relative overflow-hidden py-2 w-full"
      style={{ backgroundColor: '#5e3a1c', width: '100vw', marginLeft: 'calc(-50vw + 50%)', position: 'relative', left: 0, right: 0 }}
    >
      <div className="animate-marquee whitespace-nowrap">
        <span className="mx-4 text-sm font-medium" style={{ color: '#f5e9d0' }}>
          {announcement.text}
        </span>
        <span className="mx-4 text-sm font-medium" style={{ color: '#c2a357' }}>★</span>
        <span className="mx-4 text-sm font-medium" style={{ color: '#f5e9d0' }}>
          {announcement.text}
        </span>
        <span className="mx-4 text-sm font-medium" style={{ color: '#c2a357' }}>★</span>
        <span className="mx-4 text-sm font-medium" style={{ color: '#f5e9d0' }}>
          {announcement.text}
        </span>
        <span className="mx-4 text-sm font-medium" style={{ color: '#c2a357' }}>★</span>
        <span className="mx-4 text-sm font-medium" style={{ color: '#f5e9d0' }}>
          {announcement.text}
        </span>
        <span className="mx-4 text-sm font-medium" style={{ color: '#c2a357' }}>★</span>
        <span className="mx-4 text-sm font-medium" style={{ color: '#f5e9d0' }}>
          {announcement.text}
        </span>
        <span className="mx-4 text-sm font-medium" style={{ color: '#c2a357' }}>★</span>
      </div>
      <button
        onClick={() => setDismissed(true)}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1 hover:opacity-70"
        style={{ color: '#f5e9d0' }}
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
